// ============================================
// @engine/render2d — Lighting module
// ============================================

export {
  type Light2D,
  type Light2DBase,
  type PointLight2D,
  type SpotLight2D,
  type DirectionalLight2D,
  type AmbientLight2D,
  type ShadowProperties,
  type EmissionMode,
  type IESProperties,
  type VolumetricProperties,
  createPointLight,
  createSpotLight,
  createDirectionalLight,
  createAmbientLight,
} from './Light2D';

export {
  kelvinToRGB,
  applyTint,
  resolveEmissionColor,
  KELVIN_PRESETS,
} from './kelvinToRGB';

export {
  GPU_LIGHT_STRUCT,
  type GPULightFields,
  LIGHT_UNIFORMS,
  type LightUniformFields,
  GPULightType,
  MAX_LIGHTS,
  GPU_LIGHT_SIZE,
  LIGHT_BUFFER_SIZE,
  getMaxLights,
  getMaxShadowLights,
  getShadowMapResolution,
  getMaxShadowEdges,
  graphicsConfig,
} from './LightLayouts';

export { LightManager } from './LightManager';

export { LightCullPass, TILE_SIZE, MAX_LIGHTS_PER_TILE, TILE_STRIDE } from './LightCullPass';

export { VFXLightInjectPass, type LightEmittingSystem } from './VFXLightInjectPass';

export { LightingComputePass } from './LightingComputePass';

export { ShadowMapPass } from './ShadowMapPass';

export {
  VolumetricLightingPass,
  type VolumetricLightingConfig,
} from './VolumetricLightingPass';

export {
  IESProfileManager,
  type IESProfile,
  type IESPreset,
  IES_PRESETS,
  IES_PROFILE_RESOLUTION,
  MAX_IES_PROFILES,
  generateIESPreset,
  createIESProfile,
} from './IESProfileManager';

export {
  type ShadowCaster2D,
  type ShadowCasterShape,
  type ShadowBoxShape,
  type ShadowCircleShape,
  type ShadowPolygonShape,
  type ShadowEdgesShape,
  extractEdges,
  createShadowBox,
  createShadowCircle,
  createShadowPolygon,
} from './ShadowCaster2D';

export {
  MAX_SHADOW_LIGHTS,
  SHADOW_MAP_RESOLUTION,
  MAX_SHADOW_EDGES,
} from './LightLayouts';

export {
  type GraphicsConfig,
  type RenderPath,
  DEFAULT_GRAPHICS_CONFIG,
  setGraphicsConfig,
  getTileOverrides,
  getShadowSamplingOverrides,
  getShadowComputeOverrides,
  getLightAccumOverrides,
  getForwardPlusOverrides,
} from '../GraphicsConfig';
